<template>
	<div>
		<div class="row">
			<!-- Child's Name -->
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<div class="form-group">
					<label
						>Child's Full Name
						<span class="required-star">*</span></label
					>
					<app-input
						type="text"
						v-model="local_child.child_first_name"
						placeholder="Child's Full Name"
						name="child_first_name[]"
						required
					/>
				</div>
			</div>
			<!-- <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<div class="form-group">
					<label
						>Child's Last Name
						<span class="required-star">*</span></label
					>
					<app-input
						type="text"
						v-model="local_child.child_last_name"
						placeholder="Child's Name"
						name="child_last_name[]"
						required
					/>
				</div>
			</div> -->
		</div>
		<div class="row">
			<!-- Child's Place of Birth -->
			<!-- <div class="col-md-4">
				<div class="form-group">
					<label
						>Child's Place of Birth
						<span class="required-star">*</span></label
					>
					<app-input
						type="text"
						:required="true"
						placeholder="Child's Place of Birth"
						v-model="local_child.child_place_of_birth"
					/>
				</div>
			</div> -->
			<!-- Child's Date of Birth -->
			<div class="col-md-6 ">
				<div class="form-group">
					<label
						>Date of Birth (dd-mm-yyyy)
						<span class="required-star">*</span></label
					>
					<div class="d-flex gap-2">
						<app-input
							type="number"
							min="1"
							max="31"
							v-model="day"
							placeholder="DD"
							class="w-1/3"
						/>
						<app-input
							type="number"
							min="1"
							max="12"
							v-model="month"
							placeholder="MM"
							class="w-1/3"
							required
						/>
						<app-input
							type="number"
							min="1900"
							max="2100"
							v-model="year"
							placeholder="YYYY"
							class="w-1/3"
							required
						/>
						<!-- Hidden input untuk kirim format YYYY-MM-DD -->
						<input
							type="hidden"
							:name="'child_date_of_birth[]'"
							:value="formattedDate"
							required
						/>
					</div>

				</div>
			</div>
			<!-- Gender -->
			<div class="col-md-6 ">
				<div class="form-group">
					<label>Gender <span class="required-star">*</span></label>
					<app-input
						:id="`input_gender-${$vnode.key}`"
						:is-need-name="true"
						:radio-checkbox-name="`input-gender-${$vnode.key}`"
						type="radio"
						:list="genderLists"
						v-model="local_child.gender" required
					/>
				</div>
			</div>
		</div>
		<div class="row">
			<!-- Child's School Name -->
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<div class="form-group">
					<label>School Name <span class="required-star">*</span></label>
					<app-input
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_school_name"
						@input="setSchoolName"
						fetch-url="school"
						placeholder="School Name"
						list-value-field="name"
						required
					/>
				</div>
			</div>
			<!-- Child's School Level -->
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
				<div class="form-group">
					<label>School Level <span class="required-star">*</span></label>
					<app-input
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_school_level"
						@input="setSchoolLevel"
						fetch-url="school-level"
						placeholder="School Level"
						list-value-field="name"
						required
					/>
				</div>
			</div>
			<!-- Free Text if Child's School Name is Other -->
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" v-if="local_child.isSchoolNameOther">
				<div class="form-group">
					<label>Please Type Your Child's School Name</label>
					<app-input
						type="text"
						v-model="local_child.school_name_other"
						placeholder="Please Type Your Child's School Name"
						name="school_name_other[]"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getCurrentInstance} from "vue";
export default {
	name: "FormChild",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			local_child: {
				...this.value,
			},
			day: '',
			month: '',
			year: '',
			input_place_of_birth: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			input_school_name: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			input_school_level: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			genderLists: [
				{ id: 1, value: "Male" },
				{ id: 2, value: "Female" },
			],
		};
	},
	methods: {
		resetPlaceOfBirth() {
			this.input_place_of_birth = {
				country_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				city: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		// setPlaceOfBirth(data) {
		// 	this.local_child.child_place_of_birth = data.id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.local_child.child_place_of_birth = data.id;
		// 	}
		// },
		setSchoolName(data) {
			this.local_child.school_name = data.id;
			this.local_child.isSchoolNameOther = false;
			if (data && data.hasOwnProperty("id")) {
				this.local_child.school_name = data.id;
				this.local_child.school_name_other = '';
				if (data.name === "Others") {
					this.local_child.school_name_other = '';
					this.local_child.isSchoolNameOther = true;
				}else if (data.name === "Not yet in school") {
					this.input_school_level = { id: 19, name: "Not yet in school" };
					this.local_child.school_level = 19;
				}
			}
		},
		setSchoolLevel(data) {
			this.local_child.school_level = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.local_child.school_level = data.id;
			}
		},
	},
	computed: {
		formattedDate() {
			if (this.year && this.month && this.day) {
				const mm = String(this.month).padStart(2, '0');
				const dd = String(this.day).padStart(2, '0');
				return `${this.year}-${mm}-${dd}`;
			}
			return '';
		},
		componentKey() {
			// return getCurrentInstance().vnode.key
		}
	},
	watch: {
		formattedDate(newVal) {
			this.local_child.child_date_of_birth = newVal;
			this.$emit("input", this.local_child);
		},
		local_child: {
			handler(newVal) {
				this.$emit("input", newVal);
			},
			deep: true,
		},
		"local_child.selected_country": {
			handler(oldVal, newVal) {
				if (newVal) {
					this.resetPlaceOfBirth();
				}
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
/* Style for required asterisk */
.required-star {
	color: red;
}
.mt-4 {
	margin-top: 4rem !important;
}
.mt-2 {
	margin-top: 2rem !important;
}
</style>
